module.exports = __webpack_public_path__ + "img/11.327b3e2b.png";